/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudCostMgmtCostByDimension } from './cloudCostMgmtCostByDimension';
import { CloudCostMgmtOverallSummary } from './cloudCostMgmtOverallSummary';
import { CloudCostMgmtCostTrend } from './cloudCostMgmtCostTrend';


/**
 * Dashboard overview with summary and trends
 */
export interface CloudCostMgmtDashboardResponse { 
    summary: CloudCostMgmtOverallSummary;
    /**
     * Historical cost trend (last 6 months)
     */
    cost_trend?: Array<CloudCostMgmtCostTrend>;
    /**
     * Cost breakdown by service (top services)
     */
    by_service?: Array<CloudCostMgmtCostByDimension>;
    /**
     * Cost breakdown by region (top regions)
     */
    by_region?: Array<CloudCostMgmtCostByDimension>;
}

